import VerifyEmail from "../components/VerifyEmail";
import Layout from "../components/Layout";
import { Container } from "@mui/material";

export default function VerifyEmailPage() {
  return (
    <Layout title="Verify Email" content="Verify Email Page">
      <Container component="main" maxWidth="xs">
        <VerifyEmail />
      </Container>
    </Layout>
  );
}
